import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { OrgaoSetorialistaService } from '../services/orgao-setorialista.service';


@Injectable({
  providedIn: 'root'
})
export class OrgaoSetorialistaResolver implements Resolve<boolean> {

  constructor(private service: OrgaoSetorialistaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}